import React from "react";
import "../Style/footer.css";

function FooterTop() {
  return (
    <div className="footer">
      <div className="ft_up">
        <div className="ft_top">Members Online:</div>
        <div className="ft_bottom">
          (<b>444 Members</b> and <b>2944 Guests</b> online in{" "}
          <b>last 5 minutes</b>!)
        </div>
      </div>
      <div className="ft_down">
        (<a href="">Go up</a>)
      </div>
    </div>
  );
}

export default FooterTop;
